export const uniqueArrayBy = (inputArray, uniqueKey) => {
  const unique = [];
  const seen = {};
  inputArray.map(item => {
    if (!seen[item[uniqueKey]]) {
      seen[item[uniqueKey]] = item;
      unique.push(item);
    }
  });
  return unique;
};
export const orderArrayBy = (inputArray, key) => {
  if (!inputArray || inputArray.lenghth === 0) {
    return inputArray;
  }
  return inputArray.sort((a, b) => {
    return a[key] - b[key];
  });
};